import React, { useState } from 'react'
import { useContext } from 'react';
import { GlobalState } from '../../GlobalState';
import { api } from '../../util/urlConfig';
import moment from 'moment';
import './supplierFeedbackNotifyComponent.css'
import { useEffect } from 'react';
import axios from '../../helpers/axios';

export default function BottleReturnNotifyComponent({ id }) {
    const [bottleReturnDetail, setBottleReturnDetail] = useState(null);
    //Import Global State
    const state = useContext(GlobalState);
    const [allCustomers] = state.customerAPI.allCustomers;

    const getCustomer = (id) => {
        return allCustomers.filter(customer => customer.id === id);
    }

    const getBottleReturnDetail = async (bottleId) => {
        const res = await axios.get(`/bottlereturn/byid/${bottleId}`);
        setBottleReturnDetail(res.data.response.data)
    }

    useEffect(() => {
        getBottleReturnDetail(id);
    }, [id, allCustomers])

    return (
        <>
            {
                bottleReturnDetail ?
                    <div className='notify-main-container'>
                        <div className='notify-content-area'>
                            <img className='notify-img' src={bottleReturnDetail.customer && bottleReturnDetail.customer.upload_image ? api + "/" + bottleReturnDetail.customer.upload_image.image_url : "/img/dummy_avatar.png"} alt="avatar" />
                            <div className='notify-content-detail'>
                                <div className='notify-name'>
                                    {
                                        bottleReturnDetail.customer ? getCustomer(bottleReturnDetail.customer.id)[0].first_name + " " + getCustomer(bottleReturnDetail.customer.id)[0].last_name
                                            : bottleReturnDetail.created_by ? bottleReturnDetail.created_by.first_name + " " + bottleReturnDetail.created_by.last_name : ""
                                    }
                                </div>


                                <div className='notify-subname'>You have returned {bottleReturnDetail.quantity} quantity of products.</div>
                                <div className='notify-subname'>
                                    <i className='uil uil-clock'></i>
                                    <span>{moment(bottleReturnDetail.create_at).format('DD-MM-YYYY')}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    : <></>
            }
        </>
    )
}
